/* MILO_COOKIEBAR_I18N_PREPEND_v2 */
(function(){
  function run(){
    var locale=((window.Shopify&&Shopify.locale)||'').toLowerCase();
    var path=window.location.pathname||'';
    var lang=path.indexOf('/de')===0||locale.indexOf('de')===0?'de':(path.indexOf('/en')===0||locale.indexOf('en')===0?'en':'nl');
    var copy={
      nl:['🍪 Deze website maakt gebruik van cookies om de beste ervaring aan te bieden.','Lees meer'],
      en:['🍪 This website uses cookies to provide the best experience.','Read more'],
      de:['🍪 Diese Website verwendet Cookies, um die bestmögliche Erfahrung zu bieten.','Mehr erfahren']
    }[lang];
    function root(){return window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:(lang==='de'?'/de-de/':(lang==='en'?'/en/':'/'));}
    function setCopy(){
      var p=document.querySelector('.shopify-pc__banner__body p, [class*="shopify-pc__banner__body"] p');
      if(!p||p.getAttribute('data-milo-cookiebar-lang')===lang)return!!p;
      var a=p.querySelector('a')||document.createElement('a');
      p.textContent=copy[0]+' ';
      a.href=root()+'policies/privacy-policy';a.textContent=copy[1];a.target='_blank';a.rel='noopener noreferrer';
      p.appendChild(a);p.setAttribute('data-milo-cookiebar-lang',lang);return true;
    }
    var tries=0,t=setInterval(function(){if(setCopy()||tries++>120)clearInterval(t);},250);
    if(window.MutationObserver)new MutationObserver(setCopy).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
    document.addEventListener('DOMContentLoaded',setCopy);
  }
  run();
})();

// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
            document.getElementById('product-grid').classList.remove('product-gallery');
            // Remove 'active' class from gridv on mobile
              if (window.innerWidth < 992) { 
                document.querySelector(".gridv").classList.remove('active_mobile'); 
              }  
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
            document.getElementById('product-grid').classList.remove('product-gallery');
        }else if(this.classList.contains('galleryv')){
            document.getElementById('product-grid').classList.add('product-gallery');
            document.getElementById('product-grid').classList.remove('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }
    });
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();


// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date').replaceAll('-','/')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}
